export default class Utils {
    static countProps(obj) {
        return Object.keys(obj).length;
    }
}


